RivalIQ.module('utils', function (utils, App, Backbone, Marionette, $, _) {

    'use strict';

    // A metric value with optional prefix & suffix.
    const metricValue = utils.metricValue = function (root, prefix, suffix) {
        this.root = root.toString();
        this.prefix = prefix ? prefix.toString() : null;
        this.suffix = suffix ? suffix.toString() : null;

        return this;
    };

    metricValue.prototype.toString = function () {
        return (this.prefix || '') + this.root + (this.suffix || '');
    };
});
